import React, { Component } from 'react';
import { object } from 'prop-types';
import { map } from 'lodash';
import { Text, FlexContainer, Row, Column } from '../../common';

export default class OriginalShipping extends Component {
    static propTypes = {
        data: object
    }

    render () {
        const { data } = this.props;
        return (
            <>
                <Text semibold size={13} text='Información de envío original' />
                <FlexContainer mY={15} direction='column' mR={15}>
                    { map(data, ({ label, value }) => (
                        <Row pB={3}>
                            <Column>
                                <Text size={11} text={label} semibold color='#969696' />
                            </Column>
                            <Column>
                                <Text size={11} text={value} color='#969696' align='right' />
                            </Column>
                        </Row>
                    ))}
                </FlexContainer>
            </>
        );
    }
}
